import { render, staticRenderFns } from "./LeadChannelsView.vue?vue&type=template&id=670a6449&scoped=true&"
import script from "./LeadChannelsView.vue?vue&type=script&lang=js&"
export * from "./LeadChannelsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670a6449",
  null
  
)

export default component.exports